<template>
  <div class="input-holder" @click.stop.prevent="selectInput">
    <div
      class="label"
      v-show="!hasFocus"
      v-bind:class="{ radius: modelValue > 999 }"
    >
      {{ modelValue + ' x' }}
    </div>
    <input
      class="quantity-input"
      type="text"
      @focus="onFocus"
      @blur="checkVal($event.target.value)"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      inputmode="number"
      ref="input"
    />
  </div>
</template>

<script>
export default {
  props: ['modelValue'],
  emits: ['update:modelValue', 'set-selectable'],
  data: function () {
    return {
      hasFocus: false
    }
  },
  methods: {
    checkVal(val) {
      this.$emit('set-selectable', true)
      this.hasFocus = false
      if (isNaN(val) || val < 1) {
        this.$emit('update:val', 1)
      }
    },
    selectInput() {
      this.hasFocus = true
      this.$refs.input.select()
    },
    onFocus() {
      this.$emit('set-selectable', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/helpers/_mixins.scss' as *;

.input-holder {
  display: inline-block;
}

.quantity-input {
  -webkit-appearance: none;
  @include eclipse(39px);
  border: 1px solid #979797;
  text-align: center;
  margin: 0;
}

.label {
  position: absolute;
  background: #fff;
  margin-top: 14px;
  margin-left: 3px;
  width: 33px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.radius {
  border-radius: 0 0 18px 18px;
}
</style>
